import { render } from "./designfoodslide1.vue?vue&type=template&id=216d7728&scoped=true"
import script from "./designfoodslide1.vue?vue&type=script&lang=js"
export * from "./designfoodslide1.vue?vue&type=script&lang=js"

import "./designfoodslide1.vue?vue&type=style&index=0&id=216d7728&lang=less&scoped=true"

import exportComponent from "/Users/zhoubenhao/Desktop/行云/numatch/numatch-home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216d7728"]])

export default __exports__